// Card #1652 (design §6.1/§6.2 type 5) — the most prominent element of the
// Post-Ride / Score single-entry layout: the combined confirmed result.
// Copy is fixed to "confirmed score" (design §4.5/§6.2: never "final
// score"). `scoreHero` is a percentage number, already status-gated
// server-side (score-api's lib/scoreboard-mode-payload.js composePostRideScore
// only emits it once the ride is CONFIRMED/FINAL, never while PARTIAL) —
// this component only has to decide whether to render at all (undefined ->
// nothing) and how to format the number.
//
// Card #1694 AC4 — formatting goes through score-common's formatPercentage
// (3 decimals, single shared formatter across the FEs) rather than a local
// `.toFixed()`; it already Number()-coerces and falls back to "—" for a
// non-numeric value, so this kiosk still never white-screens on a bad wire
// value (no error boundary here).
import { formatPercentage } from "score-common";
import "./ScoreHero.css";

export default function ScoreHero({ scoreHero }) {
  if (scoreHero == null) return null;

  return (
    <div className="score-hero" data-testid="score-hero">
      <p className="score-hero__caption" data-testid="score-hero-caption">
        confirmed score
      </p>
      <p className="score-hero__value" data-testid="score-hero-value">
        {formatPercentage(Number(scoreHero))}
      </p>
    </div>
  );
}
